import { GeoPlaceService } from "~/entity/Geo/api/service";

export const useGeoPlace = () => {
  // GET
  const getGeoPlaceById = GeoPlaceService.GET.byId;
  const getGeoPlaces = GeoPlaceService.GET.getGeoPlaces;

  // POST
  const addGeoPlace = GeoPlaceService.POST.add;

  // PUT
  const setGeoPlace = GeoPlaceService.PUT.set;

  // DELETE
  const deleteGeoPlace = GeoPlaceService.DELETE.delete;

  return {
    // GET
    getGeoPlaceById,
    getGeoPlaces,

    // POST
    addGeoPlace,

    // PUT
    setGeoPlace,

    // DELETE
    deleteGeoPlace,
  };
};
